export const BOSS_SEASONS_FULL = [
  { key: "blade-out", label: "Blade Out" },
  { key: "rewind", label: "Rewind" },
  { key: "seek-within", label: "Seek Within" },
  { key: "forge-ahead", label: "Forge Ahead" },
  { key: "ever-aflame", label: "Ever Aflame" },
] as const

export type BossSeason = (typeof BOSS_SEASONS_FULL)[number]["label"]

export const BOSS_SEASONS = Object.freeze(
  BOSS_SEASONS_FULL.map((s) => s.label),
) as unknown as readonly [BossSeason, ...BossSeason[]]
